import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

export default {
  state: {
    boloes: [],
    configuracoesBolao: {},
    boloesArmazenados: [],
  },
  getters: {
    boloes(state: any) {
      return state.boloes;
    },
    configuracoesBolao(state: any){
      return state.configuracoesBolao;
    },
    boloesArmazenados(state: any){
      return state.boloesArmazenados;
    },
  },
  mutations: {
    setBoloes(state: any, boloes: any) {
      state.boloes = boloes;
    },
    setConfiguracoesBolao(state: any, configuracoesBolao: any) {
      state.configuracoesBolao = configuracoesBolao;
    },
    setBoloesArmazenados(state: any, boloesArmazenados: any) {
      state.boloesArmazenados = boloesArmazenados;
    },
    
  },
  actions: {
    getDadosBolao({ commit }: { commit: any }, filtro: any) {
      let filtros = `status=${filtro.status}&tipo=${filtro.tipo}`;
      if(filtro.numeroConcurso){
        filtros += `&numeroConcurso=${filtro.numeroConcurso}`; 
      }
      if(filtro.pontosAcertatados){
        filtros += `&pontosAcertatados=${filtro.pontosAcertatados}`;
      }
      
      return new Promise((resolve, reject) => {        
        http
          .get(`/api/v1/bolao/findDadosBolao?${filtros}` )
          .then((result: any) => {
            commit("setBoloes", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getSettingsBolao({ commit }: { commit: any }) {
      return new Promise((resolve, reject) => {        
        http
          .get("/api/v1/bolao/findConfiguracoesBolao" )
          .then((result: any) => {
            commit("setConfiguracoesBolao", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getDadosUsuarios({ commit }: { commit: any }, idBolao: any) {
      return new Promise((resolve, reject) => {        
        http
          .get("/api/v1/apostaBolao/findUsuariosBolao/"+idBolao )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    saveBolao({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {        
        http
          .post("/api/v1/bolao/save", payload )
          .then((result: any) => {
            commit("setBoloes", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    saveSettingsBolao({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {        
        http
          .post("/api/v1/bolao/saveSettings", payload )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    removeBolao({ commit }: { commit: any }, id: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {        
        http
          .delete("/api/v1/bolao/delete?id="+ id )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    getBoloesArmazenados({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {        
        http
          .get("/api/v1/bolaoarmazenado?qtdeNumeros="+payload.qtdeNumeros+"&qtdeBoloes="+payload.qtdeBoloes+"&tipo="+payload.tipo )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getBoloesArmazenadosByDescricao({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {        
        http
          .get("/api/v1/bolaoarmazenado/findByDescricao?descricao="+payload.descricao+"&qtdeNumeros="+payload.qtdeNumeros+"&qtdeBoloes="+payload.qtdeBoloes+"&tipo="+payload.tipo )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    saveBolaoArmazenado({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {        
        http
          .post("/api/v1/bolaoarmazenado", payload )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response.data.message || err);
            try {
              reject(err.response.data.message);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
  },
};
